const backendDomain = "http://192.168.1.144:3001/api";

const SummaryApi = {
  CreateProduct: {
    url: `${backendDomain}/PRODUCT_CREATE`,
    method: "POST",
  },
  getActiveProduct :{
    url: `${backendDomain}/product_retrieve_all_active`,
    method: "GET",
  },
   getAllProduct :{
    url: `${backendDomain}/product_retrieve_all`,
    method: "GET",
  },
  productImage:{
    url:`${backendDomain}/uploads`
  },
};
export default SummaryApi;
        